import { StanButton, StanModal } from '@/components';

interface CancelAppointmentModalProps {
    isOpen: boolean;
    onClose: () => void;
    bookingTitle: string;
    attendeeName: string;
    onDelete: () => void;
    isDeleting?: boolean;
}

export function CancelAppointmentModal({
    isOpen,
    onClose,
    bookingTitle,
    attendeeName,
    onDelete,
    isDeleting = false,
}: CancelAppointmentModalProps) {
    return (
        <StanModal id='cancel-appointment-modal' isOpen={isOpen} onClose={onClose} title='Are you sure?' size='sm'>
            <div className='space-y-6'>
                {/* Confirmation Message */}
                <p className='text-gray text-body-sm text-center'>
                    Just confirming that you want to cancel &quot;{bookingTitle}&quot; appointment with {attendeeName}.
                    This action cannot be undone.
                </p>

                {/* Action Buttons */}
                <div className='flex flex-col gap-3'>
                    <StanButton
                        name='confirm-delete'
                        onClick={onDelete}
                        color='destructive'
                        className='w-full'
                        disabled={isDeleting}
                        loading={isDeleting}
                    >
                        Delete Appointment
                    </StanButton>
                    <StanButton
                        name='cancel-delete'
                        onClick={onClose}
                        variant='ghost'
                        className='w-full'
                        disabled={isDeleting}
                    >
                        Cancel
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
}
